import { css } from "@emotion/react"
import Select from "react-select"
import { connectField } from "uniforms"

const SelectFromOptions = ({ disabled, id, label, name, onChange, placeholder, value, options = [], multi = false }) => {
  // Convert primitive value(s) to option object(s) that react-select expects
  const getSelectedValue = () => {
    if (multi) {
      // For multi-select, value should be an array of primitives, convert to array of option objects
      if (Array.isArray(value)) {
        return value.map(val => options.find(opt => opt.value === val)).filter(Boolean)
      }
      return []
    } else {
      // For single select, value should be a primitive, convert to option object
      if (value !== null && value !== undefined && value !== "") {
        return options.find(opt => opt.value === value) || null
      }
      return null
    }
  }

  return (
    <section
      css={css`
        width: 100%;
        @media screen and (min-width: 768px) {
          flex-wrap: nowrap !important;
        }
      `}
      className="input-row"
    >
      {label && (
        <label
          htmlFor={id}
          css={css`
            @media screen and (min-width: 768px) {
              min-width: 30.1138947236%;
            }
          `}
        >
          {label}*
        </label>
      )}

      <Select
        required
        id={id}
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        value={getSelectedValue()}
        onChange={v => onChange(multi ? (v ? v.map(opt => opt.value) : []) : v ? v.value : null)}
        options={options}
        isMulti={multi}
        isClearable
        isSearchable
        classNamePrefix="cl-select"
        styles={{
          input: provided => ({
            ...provided,
            border: "none",
            padding: 0,
            margin: 0,
            boxShadow: "none",
            background: "transparent",
          }),
          menu: provided => ({
            ...provided,
            zIndex: 9999,
            position: "relative",
          }),
          menuPortal: provided => ({
            ...provided,
            zIndex: 9999,
          }),
          menuList: provided => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
        menuPortalTarget={document.body}
      />
    </section>
  )
}

export default connectField(SelectFromOptions)
